module.exports = __webpack_public_path__ + "static/media/dollar-green.857953ff.svg";